import { FC } from 'react';
import { EmployeeTaxData } from '@pxtra-client-lib-legacy/gen';
import { DataGrid } from '../../../../lib/components/compound/dataGrid';
import { EmployeeDataGridElement } from '../shared/dataGridElement';
import { Loading } from '../../../../lib/components';

interface Props {
  data: EmployeeTaxData | undefined;
}

export const TaxDataView: FC<Props> = ({ data }) => {
  return data ? (
    <DataGrid>
      <EmployeeDataGridElement data={data} field="children_count" />
      <EmployeeDataGridElement data={data} field="kinderfreibetrag" />
      <EmployeeDataGridElement data={data} field="steuerklasse" />
      <EmployeeDataGridElement
        data={data}
        field="religion"
        type="boolean"
        renderValue={(religion) => (religion ? true : false)}
      />
    </DataGrid>
  ) : (
    <Loading />
  );
};
